export const getAngularIframeWindow = (): any => {
  const iframeWindow = (document.getElementById('OhsAngularIframeId') as any)
    ? ((document.getElementById('OhsAngularIframeId') as any).contentWindow as any)
    : null;
  return iframeWindow;
};

export const getAngularIframeInjector = (objName: string): any => {
  const iframeWindow = getAngularIframeWindow();
  if (iframeWindow)
    return iframeWindow.angular.element(iframeWindow.document.body).injector().get(objName);
  return null;
};

export const openAngularIframeModal = (modalName: string, modalData: any | null) => {
  const $rootScope = getAngularIframeInjector('$rootScope');
  $rootScope.openModal(modalName, modalData);
};

export const broadcastAngularIframe = (name: string, data: any) => {
  const $rootScope = getAngularIframeInjector('$rootScope');
  if ($rootScope) {
    $rootScope.$broadcast(name, data);
  } else {
    console.error('$rootScope is not available. Ensure the AngularJS app is loaded.');
  }
};

export const broadcastToAngularParent = (name: string, data: any) => {
  // Get the parent window (the AngularJS app)
  const parentWindow = window.parent;
  if (!parentWindow) return;

  // Get the iframe element in the parent (your AngularJS app)
  const iframe = parentWindow.document.getElementById('OhsAngularIframeId');
  if (!iframe) return;

  // Get the AngularJS injector from the parent window
  // @ts-ignore
  if (parentWindow.angular) {
    // @ts-ignore
    const injector = parentWindow.angular.element(parentWindow.document.body).injector();
    if (injector) {
      const $rootScope = injector.get('$rootScope');
      $rootScope.$broadcast(name, data);
    }
  }
};
